import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, from } from "rxjs";

import { mergeMap } from "rxjs/operators";
import { AuthService } from "@app/auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.authService.getAccessToken()).pipe(
      mergeMap((token) => {
        if (token) {
          const authReq = request.clone({
            headers: request.headers.set("Authorization", `Bearer ${token}`),
          });
          return next.handle(authReq);
        }
        return next.handle(request);
      })
    );
  }
}
